var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M475.79 277.045C462.296 317.945 433.225 362.77 390.444 377.362C325.803 399.416 320.028 452.431 202.708 452.069C184.416 452.014 167.437 450.099 151.772 446.599C143.351 444.719 135.307 442.369 127.652 439.598C58.153 414.528 20.101 354.907 14.671 291.197C7.51599 207.403 64.54 165.128 101.7 140.229C138.86 115.33 181.231 22.777 296.567 22.227C314.152 22.151 331.766 23.874 348.922 27.82C388.085 36.811 428.38 58.49 452.586 91.522C454.403 94.004 456.143 96.548 457.816 99.144C490.464 149.943 494.191 221.286 475.79 277.045Z",
    fill: "#3AF2AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M475.79 277.045C462.296 317.945 433.225 362.77 390.444 377.362C325.803 399.416 320.028 452.431 202.708 452.069C184.416 452.014 167.437 450.099 151.772 446.599C143.351 444.719 135.307 442.369 127.652 439.598C58.153 414.528 20.101 354.907 14.671 291.197C7.51599 207.403 64.54 165.128 101.7 140.229C138.86 115.33 181.231 22.777 296.567 22.227C314.152 22.151 331.766 23.874 348.922 27.82C388.085 36.811 428.38 58.49 452.586 91.522C454.403 94.004 456.143 96.548 457.816 99.144C490.464 149.943 494.191 221.286 475.79 277.045Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M481.287 460.703H15.904",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.874 423.218C35.874 423.218 50.569 166.244 491.795 142.883",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M439.798 125.55C456.593 139.247 465.41 160.612 469.834 181.328C479.012 224.313 474.714 270.597 453.395 309.459C430.888 350.489 391.14 380.042 348.44 397.602C257.919 434.827 142.691 410.42 91.2891 322.093C90.7321 321.132 90.1811 320.167 89.6381 319.199C84.6561 310.29 80.054 300.671 78.076 290.586",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M294.39 314.775H37.135C33 314.775 29.648 311.423 29.648 307.288V52.3C29.648 48.165 33 44.813 37.135 44.813H294.39C298.525 44.813 301.877 48.165 301.877 52.3V307.288C301.876 311.423 298.525 314.775 294.39 314.775Z",
    fill: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M300.948 308.49H43.694C39.559 308.49 36.207 305.138 36.207 301.003V46.0151C36.207 41.8801 39.559 38.5281 43.694 38.5281H300.949C305.084 38.5281 308.436 41.8801 308.436 46.0151V301.003C308.435 305.138 305.083 308.49 300.948 308.49Z",
    fill: "#40B0D5",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M240.306 171.2H104.51C97.7189 171.2 92.2139 165.695 92.2139 158.904V154.263C92.2139 147.472 97.7189 141.967 104.51 141.967H240.306C247.097 141.967 252.602 147.472 252.602 154.263V158.904C252.602 165.695 247.097 171.2 240.306 171.2Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M214.601 233.233H130.214C123.423 233.233 117.918 227.728 117.918 220.937V216.296C117.918 209.505 123.423 204 130.214 204H214.601C221.392 204 226.897 209.505 226.897 216.296V220.937C226.898 227.728 221.392 233.233 214.601 233.233Z",
    fill: "#263238"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M308.435 60.0611V47.0761C308.435 42.3551 304.608 38.5281 299.887 38.5281H44.755C40.034 38.5281 36.207 42.3551 36.207 47.0761V60.0601L308.435 60.0611Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M268.998 54.5892C271.179 54.5892 272.947 52.8211 272.947 50.6402C272.947 48.4592 271.179 46.6912 268.998 46.6912C266.817 46.6912 265.049 48.4592 265.049 50.6402C265.049 52.8211 266.817 54.5892 268.998 54.5892Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M282.326 54.5892C284.507 54.5892 286.275 52.8211 286.275 50.6402C286.275 48.4592 284.507 46.6912 282.326 46.6912C280.145 46.6912 278.377 48.4592 278.377 50.6402C278.377 52.8211 280.145 54.5892 282.326 54.5892Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M299.603 50.6402C299.603 48.4592 297.835 46.6912 295.654 46.6912C293.473 46.6912 291.705 48.4592 291.705 50.6402C291.705 52.8212 293.473 54.5892 295.654 54.5892C297.835 54.5892 299.603 52.8212 299.603 50.6402Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M395.981 65.9239C395.981 76.4649 391.049 85.8659 383.339 91.9019C377.73 96.3359 370.626 98.9709 362.934 98.9709C355.224 98.9709 348.12 96.3359 342.511 91.9019C334.801 85.8659 329.869 76.4649 329.869 65.9239C329.869 47.6559 344.665 32.8589 362.934 32.8589C381.185 32.8589 395.981 47.6549 395.981 65.9239Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M376.731 60.7429C376.731 53.1199 370.551 46.9399 362.928 46.9399C355.305 46.9399 349.125 53.1199 349.125 60.7429C349.125 68.3659 355.305 74.5459 362.928 74.5459C370.551 74.5459 376.731 68.3659 376.731 60.7429Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M383.339 91.9019C377.73 96.3359 370.626 98.9709 362.934 98.9709C355.224 98.9709 348.12 96.3359 342.511 91.9019C344.559 82.5189 352.927 75.4849 362.934 75.4849C372.923 75.4849 381.292 82.5179 383.339 91.9019Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M405.06 91.2749L444.787 99.5039L434.104 111.734L405.06 91.2749Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M405.06 91.2749L418.389 128.654L430.136 115.569L405.06 91.2749Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M434.104 111.734L433.199 121.142L430.136 115.569L405.06 91.2749L434.104 111.734Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M433.199 121.142L428.032 118.208L430.136 115.569L433.199 121.142Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M342.636 343.484V247.327C342.636 224.011 361.605 205.041 384.923 205.041C408.239 205.041 427.209 224.01 427.209 247.327V343.484H444.663V247.327C444.663 214.386 417.864 187.587 384.923 187.587H384.922C351.982 187.587 325.182 214.386 325.182 247.327V343.484H342.636Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M458.878 301.648H316.486V460.703H458.878V301.648Z",
    fill: "#B2B2B2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M458.878 315.178L316.486 457.57V460.703H330.723L458.878 332.548V315.178Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M316.486 341.259V393.24L408.077 301.648H356.096L316.486 341.259Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M458.878 301.648H316.486V460.703H458.878V301.648Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M458.878 301.648H428.908V460.703H458.878V301.648Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M376.572 364.584C376.572 359.072 372.104 354.604 366.592 354.604C361.08 354.604 356.612 359.072 356.612 364.584C356.612 368.711 359.117 372.252 362.69 373.772L360.858 395.443H372.327L370.495 373.772C374.067 372.252 376.572 368.711 376.572 364.584Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M149.341 159.549L148.027 158.756L149.675 156.441L147.214 155.502L147.756 154.084L150.113 155.336L149.863 152.457H151.553L151.282 155.336L153.66 154.084L154.181 155.502L151.72 156.462L153.389 158.757L152.033 159.55L150.698 156.943L149.341 159.549Z",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M157.642 159.549L156.328 158.756L157.976 156.441L155.515 155.502L156.057 154.084L158.414 155.336L158.164 152.457H159.854L159.583 155.336L161.961 154.084L162.482 155.502L160.021 156.462L161.69 158.757L160.334 159.55L158.999 156.943L157.642 159.549Z",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M165.944 159.549L164.63 158.756L166.278 156.441L163.817 155.502L164.359 154.084L166.716 155.336L166.466 152.457H168.156L167.885 155.336L170.263 154.084L170.784 155.502L168.323 156.462L169.992 158.757L168.636 159.55L167.301 156.943L165.944 159.549Z",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M174.245 159.549L172.931 158.756L174.579 156.441L172.118 155.502L172.66 154.084L175.017 155.336L174.767 152.457H176.457L176.186 155.336L178.564 154.084L179.086 155.502L176.625 156.462L178.294 158.757L176.938 159.55L175.603 156.943L174.245 159.549Z",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M182.547 159.549L181.233 158.756L182.881 156.441L180.42 155.502L180.962 154.084L183.319 155.336L183.069 152.457H184.759L184.488 155.336L186.866 154.084L187.387 155.502L184.926 156.462L186.595 158.757L185.24 159.55L183.905 156.943L182.547 159.549Z",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M190.849 159.549L189.535 158.756L191.183 156.441L188.722 155.502L189.264 154.084L191.621 155.336L191.371 152.457H193.061L192.79 155.336L195.168 154.084L195.689 155.502L193.228 156.462L194.897 158.757L193.541 159.55L192.206 156.943L190.849 159.549Z",
    fill: "#263238"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M325.033 353.732H142.735V362.152H325.033V353.732Z",
    fill: "#3AF2AE",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M109.896 320.106C89 320.106 72.06 337.046 72.06 357.942C72.06 378.838 89 395.778 109.896 395.778C130.792 395.778 147.732 378.838 147.732 357.942C147.732 337.046 130.793 320.106 109.896 320.106ZM109.896 385.878C94.468 385.878 81.96 373.371 81.96 357.942C81.96 342.513 94.467 330.006 109.896 330.006C125.324 330.006 137.832 342.513 137.832 357.942C137.832 373.371 125.325 385.878 109.896 385.878Z",
    fill: "#3AF2AE",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M292.257 353.732V393.22H300.023C300.021 393.147 300.012 393.076 300.012 393.002C300.012 387.938 304.117 383.833 309.181 383.833C314.245 383.833 318.35 387.938 318.35 393.002C318.35 393.075 318.341 393.147 318.339 393.22H325.034V353.732H292.257Z",
    fill: "#3AF2AE",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M249.647 353.732V376.395H254.104C254.103 376.353 254.098 376.312 254.098 376.27C254.098 373.364 256.454 371.007 259.36 371.007C262.266 371.007 264.622 373.363 264.622 376.27C264.622 376.312 264.617 376.353 264.616 376.395H268.458V353.732H249.647Z",
    fill: "#3AF2AE",
    stroke: "#263238",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step-3.7b42f956827dd9e414acec6a25aa8603.svg";
export { ForwardRef as ReactComponent };